export const reporterPaths = new Set([
  'container.reporter.firstName',
  'container.reporter.lastName',
  'container.reporter.email',
  'container.reporter.number',
  'container.reporter.relationshipToPolicyHolder',
]);

export const additionalDetailsPaths = new Set([
  'auto.data.shareAdditionalDetails',
  'abonly.data.shareAdditionalDetails',
  'property.data.shareAdditionalDetails',
]);

export const condoPaths = new Set([
  'condo.companyName',
  'condo.number',
]);
